/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file Landing Component
 * @author Dustin Gage
 */

import React, { memo, ReactElement, useEffect } from "react";

import { Link } from "react-router-dom";
import { UpdateFeed } from "../feed/UpdateFeed";
import { StringResource } from "../StringResource";
import { useSettings } from "../../api/use-settings";

export const Landing = memo(function Landing(): ReactElement {
	const { sitePath } = useSettings();

	const isRedirecting = document.body.className !== "";

	useEffect(() => {
		if (isRedirecting) {
			window.location.assign(sitePath);
		}
	}, [sitePath, isRedirecting]);

	return (
		<>
			{isRedirecting ? (
				<></>
			) : (
				<>
					<div id="InitialTriageCard" className="card card-rounded card-with-title-icon shadow">
						<div className="card-header card-header-rounded-bottom text-center">
							<h1>
								<StringResource token={StringResources.covidtriage.LandingPageHeading} />
							</h1>
						</div>

						<div className="card-body">
							<p className="card-text">
								<StringResource token={StringResources.covidtriage.LandingPageDescription} />
							</p>

							<div className="d-flex justify-content-center mt-4 mb-2">
								<Link to="triage" className="btn btn-lg btn-primary">
									<StringResource
										token={StringResources.covidtriage.LandingPageStartButton}
									/>
								</Link>
							</div>
						</div>
					</div>
					<br />
					<br />
					<UpdateFeed />
				</>
			)}
		</>
	);
});
